export default {
  GET_ALL: `#graphql
  query getOrdersDropshipping($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getOrdersDropshipping(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    {
      docs {
        order,
        status,
        dni,
        name,
        phones,
        email,
        address,
        listPrice,
        location,
        department,
        methodPay,
        methodPayCost,
        conveyor,
        conveyorCost,
        codeName,
        codeType,
        codePercent,
        codeValue,
        deliveryTime,
        mpCode,
        isWholesaler,
        isDropshipping,
        userPayConveyor,
        cod,
        tip,
        adviser,
        cart {
          product,
          sizes,
          quantityCart,
          refundedQuantity,
          quantityBonus,
          quantityTransfer,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          picked,
          tiers
        },
        deliveries {
          delivery,
          conveyor,
          tracking,
          createdBy,
          createdAt,
          deliveredBy,
          deliveredAt,
          inProgressAt,
          inProgressBy,
          declinedAt,
          declinedBy,
          deliveredAt,
          deliveredBy,
          status
        }
        createdAt,
        declinedAt,
        declinedBy,
        approvedAt,
        approvedBy,
        paidAt,
        paidBy,
        packedAt,
        packedBy,
        sentAt,
        sentBy,
        deliveredAt,
        deliveredBy,
        collectedAt,
        collectedBy,
        collectedValue,
        payU {
          orderId,
          state,
          error,
          methodPay,
          value,
          success,
          cash {
            EXPIRATION_DATE,
            REFERENCE,
            URL_PAYMENT_RECEIPT_PDF,
            URL_PAYMENT_RECEIPT_HTML,
          },
          pse {
            BANK_URL
          },
          createdAt 
        },
        payManual {
          state,
          methodPay,
          value,
          createdAt,
          createdBy
        },
        observations {
          observation,
          type,
          createdAt,
          createdBy
        },
        total,
        subtotal,
        priceDiscount,
        codeDiscount,
        totalDiscount,
        percentPriceDiscount,
        percentCodeDiscount,
        percentTotalDiscount,
        quantity
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  DECLINE: `#graphql
  mutation declineOrderDropshipping($order: String!) {
    declineOrderDropshipping(order: $order)        
  }`,

  APPROVE: `#graphql
  mutation approveOrderDropshipping($order: String!) {
    approveOrderDropshipping(order: $order)        
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveOrderDropshipping($order: String!) {
    disapproveOrderDropshipping(order: $order)        
  }`,

  COLLECT: `#graphql
  mutation collectOrderDropshipping($order: String!) {
    collectOrderDropshipping(order: $order)        
  }`,

  RETURN_COLLECT: `#graphql
  mutation returnCollectOrderDropshipping($order: String!) {
    returnCollectOrderDropshipping(order: $order)        
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/orderDropshipping.js